"use client";

import { Suspense, useState } from "react";
import { SessionProvider } from "next-auth/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/context/ThemeContext";
import ClientThemeWrapper from "@/context/ClientThemeWrapper";
import { NavigationProvider } from "@/context/NavigationContext";
import Loading from "@/app/loading";
import LoadingBar from "@/app/components/layout/LoadingBar";
import Script from "next/script";

export default function ClientProviders({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <NavigationProvider>
      <SessionProvider>
        <Script src="https://analytics-aiforteachinginnovation.efi.ed.ac.uk/script.js" data-website-id="495db355-9496-4419-b7d5-dea85cf24c0c" />
        <ThemeProvider>
          <ClientThemeWrapper>
            <QueryClientProvider client={queryClient}>
              <LoadingBar />
              <Suspense fallback={<Loading />}>
                {children}
              </Suspense>
            </QueryClientProvider>
          </ClientThemeWrapper>
        </ThemeProvider>
      </SessionProvider>
    </NavigationProvider>
  );
}